import React, { useState, useCallback, useEffect } from "react";
import { equalTo, onValue, ref, query, orderByChild, limitToLast } from "firebase/database";
import { getFirestore, collection, query as queryFirestore, where, orderBy, limit, startAfter as startAfterF, getDocs, getCountFromServer, doc, deleteDoc, getDoc } from 'firebase/firestore';
import { database } from "../../firebase";
import { v4 as uuidv4 } from 'uuid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import LoadingButton from '@mui/lab/LoadingButton';
import CircularProgress from '@mui/material/CircularProgress';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ProductosDataService from "../../services/ordenes.service";
import moment from "moment";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { semana, tipoOt, ciudades, departamentos } from "../../utils/default";
import { filterMaterialesVisibles, isNoDescMaterial } from "../../utils/specialMaterials";
import { Autocomplete, Chip, Box } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import RefreshIcon from '@mui/icons-material/Refresh';
import { getCuadrillasOnce } from '../../services/cuadrillasService';
const firestore = getFirestore();

const AlertSnack = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddOrdenes({ nextStep }) {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const ordenesCollection = collection(firestore, 'ordenes');

    // Función para normalizar texto: mayúsculas y sin tildes
    const normalizeText = (text) => {
        if (!text) return text;
        return text
            .toUpperCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, ""); // Elimina tildes pero mantiene ñ
    };

    const [cuadrillas, setCuadrillas] = useState([])
    const [loadingCuadrillas, setLoadingCuadrillas] = useState(false)
    const [errorCuadrillas, setErrorCuadrillas] = useState('')
    const [availableOrders, setAvailableOrders] = useState([]) // Órdenes disponibles de la cuadrilla seleccionada
    const [selectedOrderInfo, setSelectedOrderInfo] = useState(null) // Info de la orden seleccionada
    const [isManualNroOt, setIsManualNroOt] = useState(false) // Flag para modo manual
    const [state, setState] = useState({
        lastId: -1,
        idCuadrilla: -1,
        codCuadrilla: "",
        cuadrilla: '',
        usuarioCuadrilla: '',
        item: "",
        nroFormulario: "",
        nroOt: "",
        departamento: '',
        workOrder: "",
        nroCita: "",
        contrato: "",
        cliente: "",
        ciudad: "",
        tipoDia: 'Semana',
        tipoOt: 'Instalacion',
        date: null,
        comentarios: '',
        submitted: false,
    });
    const [spinner, setSpinner] = useState(false)
    const [snackbarInfo, setSnackbarInfo] = useState({ text: '', type: '', open: false });
    const [feriadosDelMes, setFeriadosDelMes] = useState({});
    const [alertValidationDate, setAlertValidationDate] = useState('')
    const [alertValidationFormulario, setAlertValidationFormulario] = useState('')
    const [alertValidationNroOt, setAlertValidationNroOt] = useState('')
    const [alertValidationClient, setAlertValidationClient] = useState('')

    const [alertValidationContrato, setAlertValidationContrato] = useState('')
    const [isValidating, setIsValidating] = useState(false)
    const [isOther, setIsOther] = useState(false)

    const loadCuadrillas = useCallback(async ({ showSuccess = false } = {}) => {
        setLoadingCuadrillas(true);
        setErrorCuadrillas('');

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
            try {
                await getCuadrillasOnce((data) => {
                    setCuadrillas(data);
                    if (showSuccess) {
                        setSnackbarInfo({ text: 'Cuadrillas recargadas correctamente', type: 'success', open: true });
                    }
                });
                setLoadingCuadrillas(false);
                return;
            } catch (error) {
                if (attempt === maxAttempts) {
                    const message = `Error al cargar cuadrillas: ${error.message || error.toString()}`;
                    setErrorCuadrillas(message);
                    setSnackbarInfo({ text: message, type: 'error', open: true });
                    setLoadingCuadrillas(false);
                    return;
                }

                await new Promise(resolve => setTimeout(resolve, attempt * 1200));
            }
        }
    }, []);

    useEffect(() => {
        // const topUserPostsRef = query(ref(database, 'ordenes'), orderByChild('id'), limitToLast(1));
        // onValue(topUserPostsRef, (snapshot) => {
        //     const key = snapshot.val() ? Object.keys(snapshot.val()) : 0;
        //     setState(prevState => ({ ...prevState, lastId: parseInt(key, 10) }));
        // }, {
        //     onlyOnce: true
        // });
        // onValue(ref(database, '/cuadrillas/'), (snapshot) => {
        //     setCuadrillas(Object.values(snapshot.val()))
        // }, {
        //     onlyOnce: true
        // });

        loadCuadrillas()
    }, [loadCuadrillas]);

    useEffect(() => {
        if (!state.date) {
            setFeriadosDelMes({});
            return;
        }

        const fetchFeriados = async () => {
            try {
                const dateObj = moment(state.date);
                if (!dateObj.isValid()) return;
                const year = dateObj.year();
                const month = dateObj.format("MM");
                const diasDocRef = doc(firestore, `asistencias/${year}/${month}/dias`);
                const diasDocSnap = await getDoc(diasDocRef);
                
                let loadedFeriados = {};
                if (diasDocSnap.exists()) {
                    const data = diasDocSnap.data();
                    loadedFeriados = data.feriados || {};
                }
                setFeriadosDelMes(loadedFeriados);

                const dayNum = dateObj.date();
                const dayOfWeek = dateObj.day();
                const esFeriado = !!loadedFeriados[dayNum];
                if (dayOfWeek === 0 || esFeriado) {
                    setState(prevState => ({ ...prevState, tipoDia: 'Domingo/Feriado' }));
                } else {
                    setState(prevState => ({ ...prevState, tipoDia: 'Semana' }));
                }
            } catch (err) {
                console.error("Error loading feriados: ", err);
            }
        };

        fetchFeriados();
    }, [state.date]);

    const onChangeFormulario = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (e.target.value.toString().length <= 9) {
            setState(prevState => ({ ...prevState, [name]: value }));
        }
    }

    const onChangeNroOt = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if (e.target.value.toString().length <= 9) {
            setState(prevState => ({ ...prevState, [name]: value }));
        }
    }

    const onChangeContrato = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        const longitud = value.toString().length;
        if (longitud <= 8) {
            setState(prevState => ({ ...prevState, [name]: value }));
        }
        setTimeout(() => {
            if (longitud < 7) {
                setAlertValidationContrato(`El numero ingresado es de ${longitud} dígitos y lo común es que sea de 7 u 8`);
            } else if (longitud > 7) {
                setAlertValidationContrato('');
            }
        }, 1000)
    }

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const onChangeDate = (value) => {
        const dateFrom = moment(new Date()).subtract(30, 'days').format("YYYYMMDD");
        const d = new Date(value);
        const isBeforeDate = moment(d).isBefore(moment(new Date()));
        const isBeforeMonth = moment(d).isBefore(moment(dateFrom));
        if (isBeforeDate && !isBeforeMonth) {
            setState(prevState => ({ ...prevState, date: value }));
            setAlertValidationDate('')
        } else {
            setAlertValidationDate('La fecha debe ser menor o igual a la actual y no tener un período mayor a 30 días de la fecha actual')
        }
    };

    const onChangeSelect = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        setState(prevState => ({ ...prevState, [name]: value }));
    }

    const onChangeSelectCiudad = (event, value) => {
        if (value !== 'OTRO') {
            // Guardar el valor con tildes tal como viene del array
            setState(prevState => ({ ...prevState, ciudad: value }));
            setIsOther(false)
        } else {
            setIsOther(true)
        }
    }

    const onChangeSelectDepto = (event, value) => {
        setState(prevState => ({ ...prevState, departamento: value }));
    }

    const onChangeSelectCuadrilla = (event, cuadrilla) => {
        if (!cuadrilla) {
            return;
        }

        const nroCuadrilla = cuadrilla.numero;
        const idCuadrilla = cuadrilla.id;
        const codCuadrilla = cuadrilla?.codigo;
        const usuarioCuadrilla = cuadrilla?.usuario ?? '';
        
        setState(prevState => ({ 
            ...prevState, 
            cuadrilla: nroCuadrilla, 
            idCuadrilla, 
            codCuadrilla,
            usuarioCuadrilla,
            // Limpiar campos relacionados con órdenes al cambiar cuadrilla
            nroOt: "",
            cliente: "",
            contrato: "",
            ciudad: "",
            departamento: 'CENTRAL',
            date: null,
            comentarios: ""
        }));
        
        // Cargar órdenes disponibles de la cuadrilla seleccionada
        const orders = cuadrilla.ordenes || [];
        setAvailableOrders(orders);
        setSelectedOrderInfo(null);
        setIsManualNroOt(false); // Reset modo manual
    }

    // Función para seleccionar una orden del autocomplete
    const onChangeSelectOrder = (event, orderInfo) => {
        if (orderInfo) {
            setSelectedOrderInfo(orderInfo);
            
            // Auto-completar campos si están disponibles
            const updateData = {
                nroOt: orderInfo.nroOt
            };
            
            if (orderInfo.cliente) {
                updateData.cliente = orderInfo.cliente;
            }
            
            if (orderInfo.contrato) {
                updateData.contrato = orderInfo.contrato;
            }
            
            if (orderInfo.nroCita != null && orderInfo.nroCita !== '') {
                updateData.nroCita = orderInfo.nroCita;
            }
            
            if (orderInfo.workOrder != null && orderInfo.workOrder !== '') {
                updateData.workOrder = orderInfo.workOrder;
            }
            
            if (orderInfo.ciudad) {
                // Buscar la ciudad en el array que coincida (ignorando tildes)
                const ciudadNormalizada = normalizeText(orderInfo.ciudad);
                const ciudadEncontrada = ciudades.find(c => normalizeText(c) === ciudadNormalizada);
                updateData.ciudad = ciudadEncontrada || orderInfo.ciudad;
            }
            
            if (orderInfo.departamento) {
                // Buscar el departamento en el array que coincida (ignorando tildes)
                const deptoNormalizado = normalizeText(orderInfo.departamento);
                const deptoEncontrado = departamentos.find(d => normalizeText(d) === deptoNormalizado);
                updateData.departamento = deptoEncontrado || orderInfo.departamento;
            }
            
            if (orderInfo.comentarios) {
                updateData.comentarios = orderInfo.comentarios;
            }
            
            if (orderInfo.fecha) {
                // Convertir fecha de YYYYMMDD a Date object
                const dateObj = moment(orderInfo.fecha, 'YYYYMMDD').toDate();
                updateData.date = dateObj;
                
                // Actualizar tipo de día basado en la fecha
                const day = dateObj.getDay();
                updateData.tipoDia = day === 0 ? 'Domingo/Feriado' : 'Semana';
            }
            
            setState(prevState => ({ ...prevState, ...updateData }));
        } else {
            setSelectedOrderInfo(null);
            setState(prevState => ({ 
                ...prevState, 
                nroOt: "",
                cliente: "",
                contrato: "",
                nroCita: "",
                workOrder: "",
                ciudad: "",
                departamento: 'CENTRAL',
                date: null,
                comentarios: ""
            }));
        }
    }

    // Función para alternar entre modo automático y manual
    const toggleManualMode = () => {
        const newManualMode = !isManualNroOt;
        setIsManualNroOt(newManualMode);
        
        if (newManualMode) {
            // Modo manual: limpiar selección automática
            setSelectedOrderInfo(null);
            setState(prevState => ({ 
                ...prevState, 
                nroOt: "",
                cliente: "",
                contrato: "",
                nroCita: "",
                workOrder: "",
                ciudad: "",
                departamento: 'CENTRAL',
                date: null,
                comentarios: ""
            }));
        } else {
            // Modo automático: volver a lista de órdenes
            setState(prevState => ({ 
                ...prevState, 
                nroOt: "",
                cliente: "",
                contrato: "",
                nroCita: "",
                workOrder: "",
                ciudad: "",
                departamento: 'CENTRAL',
                date: null,
                comentarios: ""
            }));
        }
    }

    const validateData = async (type, number) => {
        const searchQuery = queryFirestore(ordenesCollection, orderBy(type, 'asc'), where(type, '==', number));
        const querySnapshot = await getDocs(searchQuery);

        if (!querySnapshot.empty) {
            setSnackbarInfo({ text: `El ${type} ya existe para otra OT`, type: 'error', open: true })
            setIsValidating(false)
        } else {
            setSnackbarInfo({ text: `No existe ningun ${type} con este número`, type: 'success', open: true })
            setIsValidating(false)
        }

        setIsValidating(true)

        // const searchQuery = query(ref(database, 'ordenes'), orderByChild(type), equalTo(number));
        // onValue(searchQuery, (snapshot) => {
        //     if (snapshot.val()) {
        //         setSnackbarInfo({ text: `El ${type} ya existe para otra OT`, type: 'error', open: true })
        //         setIsValidating(false)
        //     } else {
        //         setSnackbarInfo({ text: `No existe ningun ${type} con este número`, type: 'success', open: true })
        //         setIsValidating(false)
        //     }
        // }, {
        //     onlyOnce: true
        // });
    }

    const validations = () => {
        let countErrors = 0
        if (state.nroFormulario.toString().length < 7) {
            setAlertValidationFormulario('El nro de formulario debe tener mínimo 7 digitos')
            countErrors += 1;
        } else {
            setAlertValidationFormulario('')
        }
        if (state.nroOt.toString().length < 7) {
            setAlertValidationNroOt('El nro de OT debe tener mínimo 7 digitos')
            countErrors += 1;
        } else {
            setAlertValidationNroOt('')
        }
        if (typeof state.cliente === 'string' && !isNaN(state.cliente)) {
            setAlertValidationClient('El cliente no puede ser numérico')
            countErrors += 1;
        } else {
            setAlertValidationClient('')
        }

        return countErrors > 0 ? false : true;
    }

    function generateNumericUniqueId() {
        const randomId = Math.floor(Math.random() * 9000000000) + 1000000000;
        return String(randomId);
    }


    const saveData = async () => {
        let formularioExists = false;
        // COMENTAMOS LA VALIDACION DEL FORMULARIO
        // const searchQuery = queryFirestore(ordenesCollection, orderBy('nroFormulario', 'asc'), where('nroFormulario', '==', state.nroFormulario));
        // const querySnapshot = await getDocs(searchQuery);

        // if (!querySnapshot.empty) {
        //     formularioExists = true
        // }

        // const searchQuery = query(ref(database, 'ordenes'), orderByChild('nroFormulario'), equalTo(state.nroFormulario));
        // onValue(searchQuery, (snapshot) => {
        //     if (snapshot.val()) {
        //         formularioExists = true
        //     }
        // }, {
        //     onlyOnce: true
        // });

        setTimeout(() => {
            let data = {
                idCuadrilla: state.idCuadrilla,
                codCuadrilla: state.codCuadrilla,
                cuadrilla: state.cuadrilla,
                item: state.item,
                nroFormulario: state.nroFormulario,
                nroOt: state.nroOt,
                workOrder: state.workOrder,
                nroCita: state.nroCita,
                contrato: state.contrato,
                cliente: state.cliente,
                ciudad: state.ciudad,
                departamento: state.departamento,
                tipoOt: state.tipoOt,
                date: moment(state.date).format("YYYYMMDD"),
                tipoDia: state.tipoDia,
                user: currentUser?.email,
                comentarios: state.comentarios, // Comentarios de la OT
                selectedOrderInfo: selectedOrderInfo,
                isManualOrder: isManualNroOt
            };
            if (state.usuarioCuadrilla != null && state.usuarioCuadrilla !== '') {
                data.usuarioCuadrilla = state.usuarioCuadrilla;
            }

            if (!formularioExists) {
                // Agregar materiales precargados si existen
                if (selectedOrderInfo && selectedOrderInfo.materiales && selectedOrderInfo.materiales.length > 0) {
                    const precargadosVisibles = filterMaterialesVisibles(selectedOrderInfo.materiales);
                    if (precargadosVisibles.length > 0) {
                        data.materialesPrecargados = precargadosVisibles;
                        console.log('📦 Materiales precargados:', precargadosVisibles);
                    }
                    if (selectedOrderInfo.noRequiereMateriales || selectedOrderInfo.materiales.some(isNoDescMaterial)) {
                        data.noRequiereMateriales = true;
                    }
                }
                nextStep(data)
                // ProductosDataService.create(data, uniqueId)
                //     .then(() => {
                //         const dataCuadrilla = {
                //             id: state.idCuadrilla,
                //             numero: state.cuadrilla,
                //         }
                //         sessionStorage.setItem('cuadrilla', JSON.stringify(dataCuadrilla))
                //         if (data.tipoOt === 'Mudanza externa') {
                //             sessionStorage.setItem('mudanza', true)
                //         }
                //         window.location.href = `/services/${data.id}`
                //     })
                //     .catch((e) => {
                //         setSnackbarInfo({ text: 'Ocurrió un error al guardar la OT, intente nuevamente', type: 'error', open: true })
                //     });
            } else {
                setAlertValidationFormulario('El nro de formulario ya existe para otra OT')
                setSnackbarInfo({ text: 'El nro de formulario ya existe para otra OT', type: 'error', open: true })
                setSpinner(false)
            }
        }, 1500);
    }

    const saveOrder = () => {
        // Prevenir múltiples clics
        if (spinner) {
            console.log('⚠️ Ya hay un proceso en curso, ignorando clic adicional');
            return;
        }

        let lastId = -1;
        const validateResult = validations();

        if (validateResult) {
            setSpinner(true);
            saveData()
            // const topUserPostsRef = query(ref(database, 'ordenes'), orderByChild('id'), limitToLast(1));
            // onValue(topUserPostsRef, (snapshot) => {
            //     const key = snapshot.val() ? Object.keys(snapshot.val()) : -1;
            //     lastId = parseInt(key, 10);
            //     saveData(lastId)
            // }, {
            //     onlyOnce: true
            // });
        }
    }

    const newProduct = () => {
        setState({
            cuadrilla: '',
            usuarioCuadrilla: '',
            item: "",
            nroFormulario: "",
            nroOt: "",
            contrato: "",
            cliente: "",
            ciudad: '',
            tipoOt: "",
            tipoDia: '',
            date: moment(new Date().getTime()),
            lastId: state.lastId,

            submitted: false,
        });
    }

    const handleCloseSanckbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarInfo({ text: '', type: 'info', open: false });
    };

    return (
        <Container component="main" maxWidth="xs">
            {spinner ? (
                <CircularProgress />
            ) : (
                <div className="form-container">
                    <Typography component="h1" variant="h5">
                        Nueva OT
                    </Typography>
                    <div className="order-container">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl sx={{ width: '100%' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Autocomplete
                                            options={cuadrillas.filter(c => c.id !== 0 && c.id !== 1 && c.id !== '0' && c.id !== '1')}
                                            id="disable-clearable"
                                            disableClearable
                                            loading={loadingCuadrillas}
                                            loadingText="Cargando cuadrillas..."
                                            noOptionsText={errorCuadrillas || 'No hay cuadrillas disponibles'}
                                            onChange={(e, cuadrilla) => onChangeSelectCuadrilla(e, cuadrilla)}
                                            getOptionLabel={(option) => option.usuario ? `${option.usuario} - ${option.numero}` : (option.numero || '')}
                                            fullWidth
                                            renderInput={(params) => (
                                                <TextField {...params} label="Cuadrilla" placeholder="Cuadrilla" />
                                            )}
                                        />
                                        <Tooltip title="Recargar cuadrillas">
                                            <span>
                                                <IconButton
                                                    aria-label="Recargar cuadrillas"
                                                    onClick={() => loadCuadrillas({ showSuccess: true })}
                                                    disabled={loadingCuadrillas}
                                                >
                                                    <RefreshIcon />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                    {errorCuadrillas !== '' && <MuiAlert severity="error" sx={{ marginTop: 1 }}>{errorCuadrillas}</MuiAlert>}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    className="default__textfield"
                                    id="nroFormulario"
                                    label="Nro Formulario"
                                    value={state.nroFormulario}
                                    name="nroFormulario"
                                    onChange={onChangeFormulario}
                                />
                                {/* <LoadingButton
                                    loading={isValidating}
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    sx={{ margin: '8px 0 0 10px' }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        validateData('nroFormulario', state.nroFormulario);
                                    }}
                                    disabled={state.nroFormulario === ''}
                                >
                                    Validar
                                </LoadingButton> */}
                                {alertValidationFormulario !== '' && <MuiAlert severity="error">{alertValidationFormulario}</MuiAlert>}
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, marginBottom: 1 }}>
                                    <Chip 
                                        label={isManualNroOt ? "Modo Manual" : "Desde Cuadrilla"} 
                                        color={isManualNroOt ? "warning" : "primary"}
                                        size="small"
                                    />
                                    <Button 
                                        size="small" 
                                        onClick={toggleManualMode}
                                        disabled={state.idCuadrilla === -1}
                                    >
                                        {isManualNroOt ? "Desde Cuadrilla" : "Ingresar Manual"}
                                    </Button>
                                </Box>
                                
                                {!isManualNroOt ? (
                                    // Modo Autocomplete - Órdenes de la cuadrilla
                                    <FormControl sx={{ width: '100%' }}>
                                        <Autocomplete
                                            options={availableOrders}
                                            value={selectedOrderInfo}
                                            onChange={onChangeSelectOrder}
                                            getOptionLabel={(option) => `${option.nroOt} - ${option.fecha ? moment(option.fecha, 'YYYYMMDD').format('DD/MM/YYYY') : 'Sin fecha'}${option.cliente ? ` - ${option.cliente}` : ''}`}
                                            disabled={state.idCuadrilla === -1 || availableOrders.length === 0}
                                            renderInput={(params) => (
                                                <TextField 
                                                    {...params} 
                                                    label={`Nro. OT (${availableOrders.length} disponibles)`}
                                                    placeholder={state.idCuadrilla === -1 ? "Selecciona una cuadrilla primero" : availableOrders.length === 0 ? "No hay órdenes disponibles" : "Selecciona una orden"}
                                                    required
                                                />
                                            )}
                                            renderOption={(props, option) => (
                                                <Box component="li" {...props}>
                                                    <Box>
                                                        <Typography variant="body1" component="div">
                                                            <strong>{option.nroOt}</strong>
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary">
                                                            {option.fecha ? moment(option.fecha, 'YYYYMMDD').format('DD/MM/YYYY') : 'Sin fecha'}
                                                            {option.cliente && ` - ${option.cliente}`}
                                                            {option.contrato && ` (${option.contrato})`}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        />
                                    </FormControl>
                                ) : (
                                    // Modo Manual - Campo de texto tradicional
                                    <TextField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        className="default__textfield"
                                        id="nroOt"
                                        label="Nro. OT (Manual)"
                                        value={state.nroOt}
                                        name="nroOt"
                                        onChange={onChangeNroOt}
                                    />
                                )}
                                {alertValidationNroOt !== '' && <MuiAlert severity="error">{alertValidationNroOt}</MuiAlert>}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    className="default__textfield"
                                    id="workOrder"
                                    label="Work Order"
                                    value={state.workOrder}
                                    name="workOrder"
                                    onChange={onChangeValues}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    className="default__textfield"
                                    id="nroCita"
                                    label="Nro Cita"
                                    value={state.nroCita}
                                    name="nroCita"
                                    onChange={onChangeValues}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    className="default__textfield"
                                    id="contrato"
                                    label="Contrato"
                                    value={state.contrato}
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    name="contrato"
                                    onChange={onChangeContrato}
                                />
                                {/* <LoadingButton
                                    loading={isValidating}
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    sx={{ margin: '8px 0 0 10px' }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        validateData('contrato', state.contrato);
                                    }}
                                    disabled={state.contrato === ''}
                                >
                                    Validar
                                </LoadingButton> */}
                                {alertValidationContrato !== '' && <MuiAlert severity="warning">{alertValidationContrato}</MuiAlert>}
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    className="default__textfield"
                                    id="cliente"
                                    label="Cliente"
                                    value={state.cliente}
                                    name="cliente"
                                    onChange={onChangeValues}
                                />
                                {alertValidationClient !== '' && <MuiAlert severity="error">{alertValidationClient}</MuiAlert>}
                            </Grid>


                            <Grid item xs={12}>
                                <FormControl sx={{ width: '100%' }}>
                                    <Autocomplete
                                        options={ciudades}
                                        id="disable-clearable"
                                        disableClearable
                                        value={state.ciudad || null}
                                        onChange={onChangeSelectCiudad}
                                        getOptionLabel={(option) => option}
                                        isOptionEqualToValue={(option, value) => normalizeText(option) === normalizeText(value)}
                                        fullWidth
                                        renderInput={(params) => (
                                            <TextField {...params} label="Ciudad" placeholder="Ciudad" name="ciudad" />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            {isOther &&
                                <Grid item xs={12}>
                                    <TextField
                                        variant="outlined"
                                        fullWidth
                                        className="default__textfield"
                                        id="ciudad"
                                        label="Ciudad"
                                        placeholder="Ingrese ciudad"
                                        value={state.ciudad}
                                        name="ciudad"
                                        onChange={onChangeValues}
                                    />
                                </Grid>
                            }
                            <Grid item xs={12}>
                                <FormControl sx={{ width: '100%' }}>
                                    <Autocomplete
                                        options={departamentos}
                                        id="disable-clearable"
                                        disableClearable
                                        onChange={onChangeSelectDepto}
                                        value={state.departamento}
                                        getOptionLabel={(option) => option}
                                        isOptionEqualToValue={(option, value) => normalizeText(option) === normalizeText(value)}
                                        fullWidth
                                        renderInput={(params) => (
                                            <TextField {...params} label="Departamento" placeholder="Departamento" />
                                        )}
                                    />
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DatePicker
                                        className="date-selector"
                                        label="Fecha Asistida"
                                        inputFormat="DD/MM/YYYY"
                                        value={state.date}
                                        onChange={onChangeDate}
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </LocalizationProvider>
                                {alertValidationDate !== '' && <MuiAlert severity="error">{alertValidationDate}</MuiAlert>}
                            </Grid>
                            {(() => {
                                if (!state.date) return null;
                                const dateObj = moment(state.date);
                                if (!dateObj.isValid()) return null;
                                const dayNum = dateObj.date();
                                const nombreFeriado = feriadosDelMes[dayNum];
                                if (!nombreFeriado) return null;
                                return (
                                    <Grid item xs={12}>
                                        <Typography variant="body2" sx={{ color: '#827717', backgroundColor: '#fff9c4', px: 2, py: 1, borderRadius: 1, border: '1px solid #fbc02d', fontWeight: 500 }}>
                                            🎉 Día Feriado: <strong>{nombreFeriado}</strong>
                                        </Typography>
                                    </Grid>
                                );
                            })()}
                            <Grid item xs={12}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Tipo día semana</InputLabel>
                                    <Select
                                        onChange={onChangeSelect}
                                        value={state.tipoDia}
                                        name="tipoDia"
                                        input={<OutlinedInput label="Tipo día semana" />}
                                        className="select__form"
                                        fullWidth
                                    >
                                        {semana.map((semana) => (
                                            <MenuItem key={semana} value={semana}>
                                                {semana}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl sx={{ width: '100%' }}>
                                    <InputLabel>Tipo OT</InputLabel>
                                    <Select
                                        onChange={onChangeSelect}
                                        name="tipoOt"
                                        value={state.tipoOt}
                                        input={<OutlinedInput label="Tipo OT" />}
                                        className="select__form"
                                        fullWidth
                                    >
                                        {tipoOt.map((tipo) => (
                                            <MenuItem key={tipo} value={tipo}>
                                                {tipo}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Button
                            type="button"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className="button__save"
                            onClick={saveOrder}
                            disabled={
                                spinner ||
                                state.cuadrilla === '' ||
                                state.nroFormulario === '' ||
                                state.nroOt === '' ||
                                state.contrato === '' ||
                                state.cliente === '' ||
                                state.date === null ||
                                state.ciudad === ''
                            }
                        >
                            {spinner ? 'Procesando...' : 'Siguiente'}
                        </Button>
                    </div>
                </div>
            )}
            <Snackbar open={snackbarInfo.open} autoHideDuration={2000} onClose={handleCloseSanckbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <AlertSnack onClose={handleCloseSanckbar} severity={snackbarInfo.type} sx={{ width: '100%' }}>
                    {snackbarInfo.text}
                </AlertSnack>
            </Snackbar>
        </Container>
    );
}

export default AddOrdenes;
